import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadConfig } from './environments/config-loader';

// Load configuration first, then bootstrap the app
loadConfig().then(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}).catch((err) => {
  console.error('Failed to load configuration, bootstrapping with defaults:', err);
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});
